<template>	
	<property name="Территория" :value="doc.territory">
	</property>
</template>
<script>
	import Property from '@/components/common/Property'
	export default {
		props: ['doc'],
		components: {			
			Property
		},
	}
</script>
